/**
 * 未读通知服务
 */

const BACKEND_URL = (window as any).AGIMX_CONFIG?.AI_CHAT_BACKEND_URL;

/**
 * 未读通知项
 */
export interface UnreadNotification {
  readonly taskId: number;
  readonly conversationId: number;
  readonly conversationTitle: string;
  readonly content: string;
  readonly contentPreview: string;
  readonly dateCreated: string;
}

/**
 * 未读通知列表响应
 */
export interface UnreadNotificationsResponse {
  readonly notifications: readonly UnreadNotification[];
  readonly total: number;
}

/**
 * 通知服务
 */
export const notificationService = {
  /**
   * 获取 SSE 流端点 URL
   */
  getStreamUrl(userId?: string, businessType?: string): string {
    const params = new URLSearchParams();
    if (userId) params.set('userId', userId);
    if (businessType) params.set('businessType', businessType);
    const qs = params.toString();
    return qs ? `${BACKEND_URL}/api/notifications/stream?${qs}` : `${BACKEND_URL}/api/notifications/stream`;
  },
  /**
   * 获取未读通知列表（用于初始加载或 SSE 降级）
   */
  async getUnreadNotifications(limit = 20, businessType?: string): Promise<UnreadNotificationsResponse> {
    const params = new URLSearchParams({ limit: String(limit) });
    if (businessType) params.set('businessType', businessType);
    const response = await fetch(
      `${BACKEND_URL}/api/notifications/unread?${params.toString()}`,
      { credentials: 'include' }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error ?? `请求失败: ${response.status}`);
    }

    return response.json();
  },

  /**
   * 标记单个通知为已读
   */
  async markAsRead(taskId: number): Promise<void> {
    const response = await fetch(
      `${BACKEND_URL}/api/notifications/${taskId}/read`,
      { method: 'POST',
        credentials: 'include'  // ✅
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error ?? `请求失败: ${response.status}`);
    }
  },

  /**
   * 批量标记为已读
   */
  async markAllAsRead(taskIds: readonly number[]): Promise<void> {
    const response = await fetch(
      `${BACKEND_URL}/api/notifications/read-all`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',  // ✅
        body: JSON.stringify({ taskIds })
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error ?? `请求失败: ${response.status}`);
    }
  }
};